export const normaliseSourcePage = (value: string): string | null => {
  const trimmed = value.trim();
  if (trimmed.length === 0) return null;
  const bounded = trimmed.slice(0, 160);
  const normalised = bounded.replace(/[^A-Za-z0-9/_#.-]/g, '-');
  return normalised.length > 0 ? normalised : null;
};

export const resolveSourcePageHeader = (): string | null => {
  if (typeof window === 'undefined') return null;
  return normaliseSourcePage(`${window.location.pathname}${window.location.hash}`);
};
